var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "short-buttons" }, [
    _c(
      "div",
      { staticClass: "short-buttons__list" },
      [
        _vm.phone !== ""
          ? _c(
              "a",
              {
                staticClass: "short-buttons__button custom-background-color-b",
                attrs: {
                  href: _vm.telLink,
                  "aria-label": "Telefonnummer",
                  "aria-description": "Anrufen",
                },
              },
              [_c("neo-icon", { attrs: { name: "telefon" } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.email !== ""
          ? [
              _c(
                "a",
                {
                  staticClass:
                    "short-buttons__button custom-background-color-b",
                  attrs: {
                    href: "mailto:" + _vm.email,
                    "aria-label": "E-Mail",
                    "aria-description": "Eine E-Mail schreiben",
                  },
                },
                [_c("neo-icon", { attrs: { name: "mail-alt" } })],
                1
              ),
              _vm._v(" "),
              !_vm.hasChatId
                ? [
                    _vm.webShopLink !== ""
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "short-buttons__button custom-background-color-b",
                            attrs: { href: "" + _vm.webShopLink },
                          },
                          [_c("neo-icon", { attrs: { name: "shop" } })],
                          1
                        )
                      : _c(
                          "a",
                          {
                            staticClass:
                              "short-buttons__button custom-background-color-b",
                            attrs: {
                              href: "/unverbindliche-Reservierung",
                              "aria-label": "Unverbindliche Reservierung",
                            },
                          },
                          [_c("neo-icon", { attrs: { name: "brief" } })],
                          1
                        ),
                  ]
                : _vm._e(),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }